import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Mainroutes from "./main.routes";
import { NumberProvider } from "./context/StandardContext";
import "react-toastify/dist/ReactToastify.css";
import { DateProvider } from "./context/SelectDate";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SocketProvider } from "./components/provider/socket-provider.jsx";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <NumberProvider>
      <DateProvider>
        <SocketProvider>
          <BrowserRouter>
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              stacked
            />
            <ToastContainer
              containerId="notifications"
              position="top-center"
              autoClose={3000}
            />
            <Mainroutes />
          </BrowserRouter>
        </SocketProvider>
      </DateProvider>
    </NumberProvider>
  </QueryClientProvider>,
);
